export const CREATE = 'CREATE'
export const UPDATE = 'UPDATE'
export const DELETE = 'DELETE'
export const FETCH_ALL = 'FETCH_ALL'
export const AUTH = 'AUTH'
export const LOGOUT = 'LOGOUT'
export const FETCH_BY_TAG = 'FETCH_BY_TAG'
export const FETCH_POST_BY_ID = 'FETCH_POST_BY_ID'
export const LOADING_START = 'LOADING_START'
export const LOADING_END = 'LOADING_END'
export const COMMENT = 'COMMENT'
export const USER_INFO_BY_ID= 'USER_INFO_BY_ID'
export const AUTH_FAIL= 'AUTH_FAIL'
export const AUTH_LOADING_START= 'AUTH_LOADING_START'
export const AUTH_LOADING_END= 'AUTH_LOADING_END'
